module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Our Team")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": "/our-team"
    }
  }, [_vm._v("Meet Our Team")])], 1), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Founder/CEO"), _c('br'), _vm._v("\n          Executive Advisory Board"), _c('br'), _vm._v("\n          Chapter Boards"), _c('br'), _vm._v("\n          Mission Sponsors"), _c('br'), _vm._v("\n          Corporate Sponsors"), _c('br'), _vm._v("\n          Thank You"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Photo3_OurTeam_810x370.jpg"),
      "width": "810",
      "height": "370"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73f93a11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/OurTeam.vue
// module id = 394
// module chunks = 2